// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import React from "react";
import { Link, useHistory } from "react-router-dom";
import aiArrow from "../../../../assets/images/ai-model-train-aarow.png";

/**
 * Side bar that remains visible throughout app experience
 * Contains links to editor, settings, export, etc.
 * @param param0 - {
 *      project - IProject
 * }
 */
const selectedError=""
const headersList = [
    { name: " Test Queue", path: "/operations/projects", active: "active", fontClass: "bg-color-1" },
   /* { name: " Test Results", path: "/operations/TestQueueProjects/:filesCount?", active: "active", fontClass: "bg-color-1" },
  */
    {
        name: " Batch-Process", path: "/operations/batch-process",
        active: "", fontClass: "bg-color-1"
    },
    {
        name: " Error-Review", path: "/operations/errorReviewProcess",
        active: "", fontClass: "bg-color-1"
    },
    {
        name: " Error-Review-post-Processing", path: "/operations/postProcess",
        active: "", fontClass: "bg-color-1"
    },
    
   /* {
        name: " Batch-Process", path: "/operations/batch-process",
        active: "", fontClass: "bg-color-1"
    },
    */
];

 function selectedErrors(es){
     console.log(es.target.value);
    //  const history1 = useHistory();
    //  history1.push(`/operations/editTagsData_for_PP`);
    // window.location.href=`/operations/editTagsData_for_PP`
 }
const OperationsHeader = ({ propsMatch }) => {
    const history = useHistory();
    return (
        <>
            <nav className="navbar navbar-expand-md bg-dark navbar-dark sub-nav">
                <ul className="navbar-nav nav">
                    <li className="text-right select-model-2 model-name-bg-dark"></li>
                    <li className="text-right">
                        <span className="nav-title">AI BATCH PROCESS</span>
                        <img src={aiArrow} />
                    </li>
                    {headersList && headersList.map((header, index) => {
                       
                        let activeClass = (header.path === propsMatch.path || header.path === propsMatch.url) ? "active" : "";
                           if(header.name === " Test Queue" &&propsMatch.path ==="/operations/TestQueueProjects/:filesCount?" )
                           {
                            activeClass="active";
                           }
                           if(header.name === " Error-Review" && propsMatch.path ==="/operations/editTagsData" )
                           {
                            activeClass="active";
                           }
                        // /operations/TestQueueProjects/:filesCount?
                       
                            return (
                                <li className="nav-item " key={index}>
                                    <Link className={`nav-link ${activeClass}`}
                                        title={header.name} to={header.path} role="button">
                                        <i className={header.fontClass}
                                            aria-hidden="true"></i>
                                        <span className=""> {header.name}</span>
                                    </Link>
                                </li>
                            );
                        
                       
                    })}
                </ul>
            </nav>
        </>
    );
};

export default OperationsHeader;
